import * as React from 'react';
import { AnimatedTabs, Card } from 'components';
import { Tab } from 'react-bootstrap';
import ChangeTab from './Tabs/ChangeTab';

const ExpertChangeRequestsContainer: React.FC = () => (
  <Card
    withoutPadding
    title="Список запросов на изменение"
    category="Список всех созданных запросов на изменение информации о составе и членах АПК"
  >
      <AnimatedTabs>
          <Tab title="Изменения к текущему приказу" eventKey="change">
              <ChangeTab />
          </Tab>
          <Tab title="Формирование новой комиссии" eventKey="create" disabled />
      </AnimatedTabs>
  </Card>
);

export default ExpertChangeRequestsContainer;
